


































  import {
    format,
  } from 'date-fns'
  import Vue from 'vue'
  import {
    Component,
    Prop
  } from 'vue-property-decorator'
  import CoursePurchase from '../../../api/v2/models/course_purchase'

  @Component({})
  export default class CoursePurchaseComponent extends Vue {
    @Prop({
      required: true
    })
    coursePurchase: CoursePurchase

    dateFormat(date: Date) {
      return format(date, 'YYYY/MM/DD')
    }
  }
